(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["drawer~index"],{

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(6);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/drawer/drawer.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // 样式文件
// import './style/index.scss';


var PlacementType = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};

function noop() {}

var MegDrawer = {
  name: 'MegDrawer',
  props: {
    title: utils["d" /* vueTypes */].oneOfType([utils["d" /* vueTypes */].string, utils["d" /* vueTypes */].object]),
    visible: utils["d" /* vueTypes */].bool,
    keyboard: utils["d" /* vueTypes */].bool.def(true),
    showClose: utils["d" /* vueTypes */].bool.def(true),
    // showMask: vueTypes.bool.def(true),
    placement: utils["d" /* vueTypes */].oneOf(Object.values(PlacementType)).def(PlacementType.RIGHT),
    width: utils["d" /* vueTypes */].oneOfType([utils["d" /* vueTypes */].string, utils["d" /* vueTypes */].number]).def(256),
    height: utils["d" /* vueTypes */].oneOfType([utils["d" /* vueTypes */].string, utils["d" /* vueTypes */].number]).def(256),
    maskStyle: utils["d" /* vueTypes */].object,
    wrapStyle: utils["d" /* vueTypes */].object,
    bodyStyle: utils["d" /* vueTypes */].object,
    headerStyle: utils["d" /* vueTypes */].object,
    drawerStyle: utils["d" /* vueTypes */].object,
    destroyOnClose: utils["d" /* vueTypes */].bool,
    maskClosable: utils["d" /* vueTypes */].bool.def(true),
    zIndex: utils["d" /* vueTypes */].number
  },
  data: function data() {
    return {
      prefixCls: 'meg-drawer',
      drawerRef: 'drawerRef',
      showMask: true
    };
  },
  methods: {
    onMaskClick: function onMaskClick() {
      if (!this.maskClosable) {
        return;
      }

      this.$emit('close');
    },
    onCloseClick: function onCloseClick() {
      this.$emit('close');
    },
    getWrapperStyle: function getWrapperStyle() {
      var placement = this.placement,
          width = this.width,
          height = this.height,
          wrapStyle = this.wrapStyle;

      var styles = _objectSpread({}, wrapStyle);

      if (placement === PlacementType.TOP || placement === PlacementType.BOTTOM) {
        styles.height = height + 'px';
      } else {
        styles.width = width + 'px';
      }

      return styles;
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      var showClose = this.showClose,
          prefixCls = this.prefixCls,
          title = this.title,
          headerStyle = this.headerStyle;

      if (!title && !showClose) {
        return null;
      }

      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
      return h("div", {
        "class": headerClassName,
        style: _objectSpread({}, headerStyle)
      }, [title && h("div", {
        "class": "".concat(prefixCls, "-title")
      }, [title]), showClose && h("div", {
        "class": "".concat(prefixCls, "-close"),
        on: {
          "click": this.onCloseClick
        }
      }, [h("meg-icon", {
        attrs: {
          name: "megui-close",
          width: "16",
          height: "16"
        }
      })])]);
    },
    // render drawer body dom
    renderBody: function renderBody() {
      var h = this.$createElement;
      var bodyStyle = this.bodyStyle,
          drawerStyle = this.drawerStyle,
          prefixCls = this.prefixCls;

      if (this.destroyClose && !this.visible) {
        return null;
      }

      this.destroyClose = false;
      var containerStyle = {};
      var isDestroyOnClose = this.getDestroyOnClose();

      if (isDestroyOnClose) {
        // Increase the opacity transition, delete children after closing.
        containerStyle.opacity = 0;
        containerStyle.transition = 'opacity .3s';
      }

      return h("div", {
        "class": "".concat(prefixCls, "-wrapper-body"),
        style: _objectSpread(_objectSpread({}, containerStyle), drawerStyle),
        on: {
          "transitionend": this.onDestroyTransitionEnd
        }
      }, [this.renderHeader(prefixCls), h("div", {
        key: "body",
        "class": "".concat(prefixCls, "-body"),
        style: _objectSpread({}, bodyStyle)
      }, [this.$slots.default])]);
    },
    getDestroyOnClose: function getDestroyOnClose() {
      return this.destroyOnClose && !this.visible;
    },
    onDestroyTransitionEnd: function onDestroyTransitionEnd() {
      var isDestroyOnClose = this.getDestroyOnClose();

      if (!isDestroyOnClose) {
        return;
      }

      if (!this.visible) {
        this.destroyClose = true;
        this.$forceUpdate();
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === key_code["a" /* default */].ESC) {
        e.stopPropagation();
        this.$emit('close', e);
      }
    },
    domFocus: function domFocus() {
      if (this.$refs.drawerRef) {
        this.$refs.drawerRef.focus();
      }
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      this.$nextTick(function () {
        val && _this.domFocus();
      });
    }
  },
  render: function render() {
    var _classnames;

    var h = arguments[0];
    var prefixCls = this.prefixCls,
        drawerRef = this.drawerRef,
        placement = this.placement,
        visible = this.visible,
        showMask = this.showMask,
        zIndex = this.zIndex,
        keyboard = this.keyboard,
        maskStyle = this.maskStyle;
    return h("div", {
      "class": external_classnames_default()("".concat(prefixCls), "".concat(prefixCls, "-").concat(placement), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-open"), visible), _defineProperty(_classnames, 'no-mask', !showMask), _classnames)),
      style: {
        zIndex: zIndex
      },
      attrs: {
        tabIndex: -1
      },
      on: {
        "keydown": visible && keyboard ? this.onKeyDown : noop
      },
      ref: drawerRef
    }, [showMask && h("div", {
      "class": "".concat(prefixCls, "-mask"),
      style: _objectSpread({}, maskStyle),
      on: {
        "click": this.onMaskClick
      }
    }), h("div", {
      "class": "".concat(prefixCls, "-content-wrapper"),
      style: this.getWrapperStyle()
    }, [h("div", {
      "class": "".concat(prefixCls, "-content")
    }, [this.renderBody()])])]);
  }
};
/* harmony default export */ var drawer = (MegDrawer);
// CONCATENATED MODULE: ./src/components/drawer/index.jsx


drawer.install = function (Vue) {
  Vue.component(drawer.name, drawer);
};

/* harmony default export */ var components_drawer = __webpack_exports__["default"] = (drawer);

/***/ })

}]);